module.exports = __webpack_public_path__ + "media/he-drink.82514952.mp3";